import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ContainerFlex from '~/components/containerFlex';
import useApi, { ApiMethod } from '~/hooks/useApi';
import Endpoints from '~/services/endpoints';
import Loading from '~/components/loading';
import Container from '~/components/container';
import BoxAvailableCredit from '../components/boxAvailableCredit';

interface IProps {
  type: string;
  dataFinal: string;
  dataInicial: string;
  subTitle: string;
  range: string;
  campoOrdenado: string;
  tipoOrdenacao: string;
  dataHoraColeta: string;
}

interface IBoxGraphcic {
  categories: string[];
  dataHoraColeta: string;
  series: {
    name: string;
    data: number[];
  }[];
}

const DashDetailsAvailableCredit: React.FC = () => {
  const [dataResponse, setDataResponse] = useState<IBoxGraphcic>({
    dataHoraColeta: '',
    categories: [],
    series: [
      {
        name: '',
        data: [],
      },
    ],
  });

  const { state } = useLocation<IProps>();

  const RequestGetAvailableCredits = useApi(
    Endpoints.graphc.getAvailableCredits.replace(
      'PARAM_DATA',
      state.dataHoraColeta,
    ),
    ApiMethod.GET,
  );

  useEffect(() => {
    populateGraphic();
  }, []);

  const populateGraphic = async () => {
    try {
      const response = await RequestGetAvailableCredits.callApi();

      if (response.status >= 200 && response.status < 300) {
        setDataResponse(response.data as IBoxGraphcic);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Container>
      <Loading status={RequestGetAvailableCredits.loading} />

      <ContainerFlex>
        <BoxAvailableCredit
          categories={dataResponse?.categories}
          series={dataResponse?.series}
          subTitle={state?.subTitle}
        />
      </ContainerFlex>
    </Container>
  );
};

export default DashDetailsAvailableCredit;
